var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',[_c('ErrorPageDetails',{attrs:{"status":"404","message":"Not Found"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }